<template>
  <Modal extra-class="dea-modal--phone dea-modal--no-footer" :visible="visible" @modal-close="$emit('modal-close')">
    <template #title> {{ titleLabel }} il tuo numero di telefono </template>
    <template #content>
      <InputText v-model="telephone" label="TELEFONO"></InputText>
      <Buttons class="dea-button--large" :disabled="!telephone" @click="$emit('user-update', { phone: telephone })"
        >Salva modifiche</Buttons
      >
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import InputText from "@/components/elements/InputText";
import Modal from "@/components/patterns/Modal";

export default {
  name: "PhoneModal",
  components: { Buttons, InputText, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      telephone: "",
      titleLabel: "",
    };
  },
  mounted() {
    this.telephone = this.user.phone ? this.user.phone : "";
    this.titleLabel = this.telephone ? "Modifica" : "Aggiungi";
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
</style>
